import React, { useState, useEffect } from 'react'
import { Table, Radio, Form, Flex, Space, InputNumber, Input, DatePicker} from 'antd';
import { useZzYZZQuery } from '../store/DianShangYeWuApi';
import IncomeCheck from '../document/income/IncomeCheck';
import CostCheck from '../document/cost/CostCheck';
import ExpenseCheck from '../document/expense/ExpenseCheck';
import LoanCheck from '../document/loan/LoanCheck';
import BankRecordDel from './BankRecordDel';
import Icon from '../cpn/Icon';
import dayjs from 'dayjs';
function BankRecordList(props) {
    const formId = React.useId();
    const [form] = Form.useForm();
    const [query, setQuery] = useState('');
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });
    const {data, isSuccess} = useZzYZZQuery({
        'qy_id': props.qy_id,
        'qyyhzh_id': props.qyyhzh_id,
    },{refetchOnMountOrArgChange:1,skip:!props.qyyhzh_id});
    useEffect(() => {
        if (isSuccess && data.Status==='success') {
            let arr = [...(data.Result || [])];
            // 先按日期排序，再在期初余额基础上按时间顺序计算每条记录的账户余额
            arr = arr.sort((a, b) => new Date(a.qyyhzh_date) - new Date(b.qyyhzh_date));
            let bankRemain = Number(props.bankRemain) || 0;
            arr = arr.map(item => {
                let amount = Number(item.qyyhzh_dj_amount) || 0;
                // 收入：在期初数上增加
                if(item.qyyhzh_zflx === '现收' || item.qyyhzh_zflx === '核销应收'){
                    bankRemain += amount;
                }
                // 支出：在期初数上减少
                if(item.qyyhzh_zflx === '现付' || item.qyyhzh_zflx === '核销应付'){
                    bankRemain -= amount;
                }
                return { ...item, bankRemain: bankRemain };
            });

            if(query.qyyhzh_dj_type_name){
                arr = arr.filter(item => item.qyyhzh_dj_type_name === query.qyyhzh_dj_type_name);
            }
            if(query.qyyhzh_dj_amount){
                arr = arr.filter(item => Number(item.qyyhzh_dj_amount) === Number(query.qyyhzh_dj_amount));
            }
            if(query.qyyhzh_dj_id){
                arr = arr.filter(item => item.qyyhzh_dj_id === query.qyyhzh_dj_id);
            }
            if(query.qyyhzh_date){
                console.log(query.qyyhzh_date);
                arr = arr.filter(item => dayjs(item.qyyhzh_date).format('YYYY-MM-DD') === query.qyyhzh_date);
            }
            setList(arr);
            setPagination(prev => ({ ...prev, current: 1 }));
        }
    }, [data, isSuccess,query,props.bankRemain])
    const columns = [
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return <BankRecordDel qyyhzh_dj_id={record.qyyhzh_dj_id} qyyhzh_dj_type_name={record.qyyhzh_dj_type_name}/>
            }
        },
        {
            title: '转账日期',
            dataIndex: 'qyyhzh_date',
            key: 'qyyhzh_date',
        },      
        {
            title: '转入金额',
            dataIndex: 'qyyhzh_dj_amount',
            key: 'qyyhzh_dj_amount',
            render: (text, record) => {
                if(record.qyyhzh_zflx === '现收' || record.qyyhzh_zflx === '核销应收'){
                    return <span style={{color:'red'}}>￥{Number(text).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</span>
                }else{
                    return ''
                }
            }
        },
        {
            title: '转出金额',
            dataIndex: 'qyyhzh_dj_amount',
            key: 'qyyhzh_dj_amount',
            render: (text, record) => {
                if(record.qyyhzh_zflx === '现付' || record.qyyhzh_zflx === '核销应付' || (record.qyyhzh_zflx === '应收' && record.qyyhzh_dj_type_name === '借款单')){
                    return <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</span>
                }else{
                    return ''
                }
            }
        },
        {
            title: '账户余额',
            dataIndex: 'bankRemain',
            key: 'bankRemain',
            render: (text, record) => {
                return <span>￥{Number(record.bankRemain).toLocaleString('zh-CN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}</span>
            }
        },
        {
            title: '原始单据',
            dataIndex: 'qyyhzh_content',
            key: 'qyyhzh_content',
            render: (text, record) => {
                if(record.qyyhzh_dj_type_name === '收款单'){
                    return <IncomeCheck ddsr_id={record.qyyhzh_dj_id} ddsr_kh_name={record.qyyhzh_dj_kh_name}  ddsr_kh_id={record.qyyhzh_dj_kh_id} qy_name={record.qyyhzh_dj_qy_name} qy_id={record.qyyhzh_dj_qy_id} yh_id={record.qyyhzh_dj_yh_id} yh_name={record.qyyhzh_dj_yh_name}/>
                }else if(record.qyyhzh_dj_type_name === '付款单'){
                    return <CostCheck ddzc_id={record.qyyhzh_dj_id} ddzc_kh_name={record.qyyhzh_dj_kh_name} ddzc_kh_id={record.qyyhzh_dj_kh_id} qy_name={record.qyyhzh_dj_qy_name} qy_id={record.qyyhzh_dj_qy_id} yh_id={record.qyyhzh_dj_yh_id} yh_name={record.qyyhzh_dj_yh_name}/>
                }else if(record.qyyhzh_dj_type_name === '费用单'){
                    return <ExpenseCheck fy_id={record.qyyhzh_dj_id} fy_kh_name={record.qyyhzh_dj_kh_name} fy_kh_id={record.qyyhzh_dj_kh_id} qy_name={record.qyyhzh_dj_qy_name} qy_id={record.qyyhzh_dj_qy_id} yh_id={record.qyyhzh_dj_yh_id} yh_name={record.qyyhzh_dj_yh_name}/>
                }else if(record.qyyhzh_dj_type_name === '借款单'){
                    return <LoanCheck jk_id={record.qyyhzh_dj_id} jk_kh_name={record.qyyhzh_dj_kh_name} jk_kh_id={record.qyyhzh_dj_kh_id} qy_name={record.qyyhzh_dj_qy_name} qy_id={record.qyyhzh_dj_qy_id} yh_id={record.qyyhzh_dj_yh_id} yh_name={record.qyyhzh_dj_yh_name}/>
                }
            }
        },
        {
            title: '单据类型',
            dataIndex: 'qyyhzh_dj_type_name',
            key: 'qyyhzh_dj_type_name',
        },
        {
            title: '单据编号',
            dataIndex: 'qyyhzh_dj_id',
            key: 'qyyhzh_dj_id',
        },
        {
            title: '新增记录',
            dataIndex: 'qyyhzh_ctime',
            key: 'qyyhzh_ctime',
            render: (text, record) => {
                return <span>{record.qyyhzh_uname} {record.qyyhzh_ctime}</span>
            }
        },
    ]
    return (
        <>
            <Flex>
                <Form
                    name={`bankRecordList_${formId.replace(/:/g, '-')}`}
                    form={form}
                    layout='inline'
                >
                    <Form.Item 
                        name='qyyhzh_dj_type_name'
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({...prev, qyyhzh_dj_type_name: e.target.value}));
                            }}
                        >
                            <Radio value='收款单'>收款单</Radio>
                            <Radio value='付款单'>付款单</Radio>
                            <Radio value='费用单'>费用单</Radio>
                            <Radio value='借款单'>借款单</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name='qyyhzh_dj_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, qyyhzh_dj_amount: value }));
                            }}
                            value={query.danju_amount ? query.qyyhzh_dj_amount : undefined}
                            placeholder='单据金额'
                            name='danju_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <Form.Item name='qyyhzh_dj_id' >
                        <Input placeholder='单据编号' onChange={(e) => {setQuery(prev => ({ ...prev, qyyhzh_dj_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item name='qyyhzh_dj_date' >
                        <DatePicker placeholder='转账日期' onChange={(value) => {setQuery(prev => ({ ...prev, qyyhzh_date: dayjs(value).format('YYYY-MM-DD') }))}} style={{ width: "150px" }} />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset' 
                                onClick={() => {
                                    form.resetFields();
                                    setQuery('');
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>
            </Flex>
            <Table 
                dataSource={list} 
                columns={columns} 
                bordered
                size='small'
                rowKey={(record) => record.qyyhzh_dj_type_name+'_'+record.qyyhzh_dj_id}
                style={{marginTop: '10px'}}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    pageSizeOptions: [100, 200, 500, 1000],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        setPagination(prev => ({ ...prev, current: page, pageSize: pageSize || prev.pageSize }));
                    },
                    onShowSizeChange: (current, size) => {
                        setPagination(prev => ({ current: 1, pageSize: size }));
                    }
                }}
            />
        </>
    )
}

export default BankRecordList